import { EnvelopeIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { SHARED_DATA_STATUS } from "@/domain/sharedData/constants"
import { getSharedEntityType } from "@/domain/sharedData/getSharedUtils"
import type { SharedDataJsonldReadCollectionSharedData } from "@/networking/api"
import { isNotBlank } from "@/utils/ts-utils"
import { FormattedMessage, useIntl } from "react-intl"

type Props = {
  entity: SharedDataJsonldReadCollectionSharedData
}

export const RequestSection = ({ entity }: Props) => {
  const intl = useIntl()

  const hasAnswerReason =
    ([SHARED_DATA_STATUS.REVOKED, SHARED_DATA_STATUS.DENIED] as string[]).includes(
      entity.status?.code ?? ""
    ) && isNotBlank(entity.subjectAnswer)
  // An empty "Reasons and comments" section is not shown (ADR 0009, D4).
  if (
    !hasAnswerReason &&
    ![
      entity.interBu?.projectComments,
      entity.messageAnswer,
      entity.message,
      entity.interBu?.peopleComments,
    ].some(isNotBlank)
  )
    return null

  return (
    <SheetSection
      title={intl.formatMessage({ id: "userSharedData.motivation" })}
      icon={EnvelopeIcon}
    >
      <SheetFieldGrid>
        {/*
          <SheetField label={intl.formatMessage({ id: "userSharedData.entity.subject" })}>
            <FormattedMessage
              id={`userSharedData.${getSharedEntityType(entity)}.motivation.${entity.subject}`}
            />
          </SheetField>
          */}
        {isNotBlank(entity.interBu?.projectComments) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.project_comment" })}>
            {entity.interBu?.projectComments}
          </SheetField>
        )}
        {([SHARED_DATA_STATUS.REVOKED, SHARED_DATA_STATUS.DENIED] as string[]).includes(
          entity.status?.code ?? ""
        ) &&
          isNotBlank(entity.subjectAnswer) && (
            <SheetField
              label={intl.formatMessage({ id: "userSharedData.motivation.subject_answer" })}
            >
              <FormattedMessage
                id={`userSharedData.${getSharedEntityType(entity)}.motivation.${entity.subjectAnswer}`}
              />
            </SheetField>
          )}
        {isNotBlank(entity.messageAnswer) && (
          <SheetField
            label={intl.formatMessage({ id: "userSharedData.motivation.comment_answer" })}
          >
            {entity.messageAnswer}
          </SheetField>
        )}
        {isNotBlank(entity.message) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.interbu.cluster.comment" })}>
            {entity.message}
          </SheetField>
        )}
        {isNotBlank(entity.interBu?.peopleComments) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.interbu.people.comment" })}>
            {entity.interBu?.peopleComments}
          </SheetField>
        )}
      </SheetFieldGrid>
    </SheetSection>
  )
}
